const updateAboutCache = (queryClient, stockData) => {
  stockData.forEach((stock) => {
    // query keys is based on packages/stock/src/services/stock/detail/about/index.js
    queryClient.setQueryData([`v1/stock/detail/${stock.code}/price/`], (oldData) => {
      const returnpct = stock.change_pct / 100;
      if (!oldData) {
        return {
          price: stock.price,
          return_amount: stock.cahnge,
          return_pct: returnpct,
        };
      }
      return {
        ...oldData?.data,
        price: stock.price,
        return_amount: stock.change,
        return_pct: returnpct,
      };
    });
  });
};

export default updateAboutCache;
